import { render } from "./SelecionarPeriodoMovimento.vue?vue&type=template&id=243038e6&ts=true"
import script from "./SelecionarPeriodoMovimento.vue?vue&type=script&lang=ts"
export * from "./SelecionarPeriodoMovimento.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\Desenvolvimento\\NeoXFront\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__